import { Box, Divider, Fade, Flex, HStack, IconButton, Text } from "@chakra-ui/react";
import Link from "next/link";
import { useEffect, useRef } from "react";
import { CgLoadbarDoc } from "react-icons/cg";
import { GrHelpBook } from "react-icons/gr";
import { IoMdHelp } from "react-icons/io";


export function HelperLinks({ isOpen, onOpen, onClose }) {

  const subMenuRef = useRef<HTMLDivElement | null>();

  const toggle = () => {
    if (isOpen) {
      onClose();
    } else {
      onOpen();
    }
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (subMenuRef.current && !subMenuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Box position="relative" ref={subMenuRef}>
      <IconButton
        isRound={true}
        aria-label="Help"
        variant='solid'
        fontSize="19px !important"
        padding="unset !important"
        minWidth="44px !important"
        onClick={toggle}
        boxShadow="none !important"
        icon={<IoMdHelp color="#FFF" />}
        bg="red.400"
        sx={{ width: '44px', height: '44px', 'svg path': { transition: 'fill 0.25s' } }}
        transition="background-color 0.25s"
        _hover={{
          backgroundColor: "#000",
        }}
        _active={{
          backgroundColor: "#000",
        }}
      />
      <Fade in={isOpen}>
        <Box
          position="absolute"
          top="50px"
          right="0"
          background="white.400"
          width="max-content"
          boxShadow="lg"
          rounded="md"
          border="1px solid #ebebeb"
          pointerEvents={isOpen ? 'unset' : 'none'}
        >
          <Flex
            borderRadius="6px"
            overflow="hidden"
            flexDirection="column" sx={{
              'a': {
                fontSize: '16px !important',
                lineHeight: '24px !important'
              }
            }}>
            <Link href="/docs/20241021-ENGYS-Portal_UserGuide.pdf" passHref>
              <a target="_blank">
                <HStack spacing="2" padding="10px" background="gray.100" _hover={{
                  color: 'red.400'
                }}>
                  <GrHelpBook color="red" />
                  <Text>
                    Portal User Guide
                  </Text>
                </HStack>
              </a>
            </Link>
            <Divider borderColor="gray.500" />
            <Link href="https://engys.com/website-terms" passHref>
              <a target="_blank">
                <HStack spacing="2" padding="10px" background="gray.100" _hover={{
                  color: 'red.400'
                }}>
                  <CgLoadbarDoc color="red" />
                  <Text>
                    Terms and Conditions
                  </Text>
                </HStack>
              </a>
            </Link>
            <Divider borderColor="gray.500" />
            <Link href="https://engys.com/privacy" passHref>
              <a target="_blank">
                <HStack spacing="2" padding="10px" background="gray.100" _hover={{
                  color: 'red.400'
                }}>
                  <CgLoadbarDoc color="red" />
                  <Text>
                    Privacy Notes
                  </Text>
                </HStack>
              </a>
            </Link>
            <Divider borderColor="gray.500" />
            <Link href="https://engys.com/cookies" passHref>
              <a target="_blank">
                <HStack spacing="2" padding="10px" background="gray.100" _hover={{
                  color: 'red.400'
                }}>
                  <CgLoadbarDoc color="red" />
                  <Text>
                    Cookie Policy
                  </Text>
                </HStack>
              </a>
            </Link>
          </Flex>
        </Box>
      </Fade>
    </Box>
  );
}
